/* File: src/components/LanguageChooser.jsx */
import React, { useState, useEffect } from "react";
import ReactFlagsSelect from "react-flags-select";
import { LOCALES_COUNTRIES } from "../../../../i18n";
import { useHistory } from "react-router";
import ApiRequest from "../../../../actions/ApiRequest";
import * as googleTTS from "google-tts-api"; // import module for getAudioUrl

// Mapping between two-letter codes, flags, BCP-47 tags, and display names
export const langs = { ar: "PS", en: "US", he: "IL" };
export const reverseLangs = { PS: "ar", US: "en", IL: "he" };
export const voiceLangTags = { en: "en-US", ar: "ar-SA", he: "he-IL" };
export const langNames = { US: "English", PS: "Arabic", IL: "Hebrew" };

const LanguageChooser = ({
  storageKey = "langCity",
  reloadOnChange = true,
}) => {
  const [selected, setSelected] = useState(
    langs[localStorage.getItem(storageKey)] ||
      LOCALES_COUNTRIES[process.env.REACT_APP_DEFAULT_LANG]
  );
  const history = useHistory();

  useEffect(() => {
    const stored = localStorage.getItem(storageKey);
    if (storageKey === "langCity" && stored && langs[stored]) {
      setSelected(langs[stored]);
    }
    if (storageKey === "voiceLang" && stored) {
      const code = Object.keys(voiceLangTags).find(
        (k) => voiceLangTags[k] === stored
      );
      if (code && langs[code]) setSelected(langs[code]);
    }
  }, [storageKey]);

  const onSelectLang = async (flagCode) => {
    const langCode = reverseLangs[flagCode]; // e.g. "ar","en","he"

    if (storageKey === "voiceLang") {
      // Store full BCP-47 tag
      const tag = voiceLangTags[langCode];
      localStorage.setItem(storageKey, tag);

      // Generate and play TTS confirmation via google-tts-api
      try {
        const url = googleTTS.getAudioUrl(
          `You selected ${langNames[flagCode]}`,
          { lang: langCode, slow: false, host: "https://translate.google.com" }
        );
        const audio = new Audio(url);
        await audio.play();
      } catch (err) {
        console.error("TTS error:", err);
      }
    } else {
      localStorage.setItem(storageKey, langCode);
    }

    setSelected(flagCode);

    if (storageKey === "langCity") {
      try {
        await ApiRequest.post("cdl");
      } catch (error) {
        console.error("CDL API failed", error);
      }
      if (reloadOnChange) history.go(0);
    }
  };

  return (
    <ReactFlagsSelect
      countries={["PS", "US", "IL"]}
      selected={selected}
      customLabels={langNames}
      onSelect={onSelectLang}
      selectedSize={14}
      optionsSize={14}
      showLabel={true}
      className="custom-lang"
    />
  );
};

export default LanguageChooser;
